import { render, staticRenderFns } from "./FreeAccountNotificationBar.container.vue?vue&type=template&id=3f71845b&"
import script from "./FreeAccountNotificationBar.container.vue?vue&type=script&lang=ts&"
export * from "./FreeAccountNotificationBar.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports